// extracted by mini-css-extract-plugin
export default {"cta":"dJ-z","disabled":"eJ-z"};